import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import useResponsive from "../../hooks/useResponsive";
import Menu from "./Menu";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

const MainLayout = () => {
  const isDesktop = useResponsive("up", 960);

  return (
    <>
      <Header />
      <div>{isDesktop && <Menu />}</div>
      <Outlet />
      <Footer />
    </>
  );
};

export default MainLayout;
